// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consent-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1060;
  background: rgb(25, 25, 25);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 0.875rem 1.25rem;
}

.consent-content {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  flex-wrap: wrap;
  max-width: 960px;
  margin: 0 auto;
}

.consent-text {
  margin: 0;
  font-family: 'Oxygen', sans-serif;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.8);
  flex: 1;
  min-width: 200px;
}

.consent-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: underline;
  white-space: nowrap;
}

.consent-link:hover {
  color: rgba(255, 255, 255, 0.9);
}

.consent-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/cookie-consent-banner/cookie-consent-banner.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,mBAAmB;EACnB,+BAA+B;EAC/B,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB","sourcesContent":[".consent-banner {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1060;\n  background: rgb(25, 25, 25);\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n  padding: 0.875rem 1.25rem;\n}\n\n.consent-content {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  flex-wrap: wrap;\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.consent-text {\n  margin: 0;\n  font-family: 'Oxygen', sans-serif;\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.8);\n  flex: 1;\n  min-width: 200px;\n}\n\n.consent-link {\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: underline;\n  white-space: nowrap;\n}\n\n.consent-link:hover {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.consent-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
